export const RESPONSIVE_FLUID_CLASSNAME = 'timesgrid-fluid';

export const HttpStatusCodes = {
    OK: 200,
    Created: 201,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    UnprocessableEntity: 422,
};

export function ServerException({
    errorCode, response, bookingState, errorFields, message, type, code,
}) {
    this.errorCode = errorCode;
    this.response = response;
    this.bookingState = bookingState;
    this.errorFields = errorFields;
    this.message = message;
    this.type = type;
    this.code = code;
}

export const SearchParameterToQuery = {
    address: 'address',
    carrierId: 'insurance_carrier',
    dayFilter: 'day_filter',
    directoryId: 'directory_id',
    excludeSpecialties: 'exclude_specialties',
    genderFilter: 'gender',
    ip: 'ip',
    languageId: 'language',
    name: 'name',
    pageOffset: 'offset',
    planId: 'insurance_plan',
    practiceId: 'practiceId',
    procedureId: 'reason_visit',
    showProvidersWhoSeeChildren: 'sees_children',
    showTimesAfter5: 'after_5pm',
    showTimesBefore10: 'before_10am',
    sortType: 'sort_type',
    specialtyId: 'dr_specialty',
};


export const INSURANCE_TYPES = {
    DENTAL: 1,
    HEALTH: 2,
    VISION: 3,
};

export const PROVIDER_STATUS = {
    NEW_APPLICATION: 1,
    APPROVED_APPLICATION: 2,
    DELETED: 4,
    RESOURCE: 5,
    LOCKED: 60,
    CHURNED: 61,
};
